import angular from 'angular';
import emailTemplateFields from './emailTemplateFields';

export default angular
  .module('scenes.emailTemplateFields', [])
  .component('emailTemplateFields', emailTemplateFields).name;
